// @flow
import React from 'react';
import {
  StyledModal,
  ModalInner,
  ModalTitle,
  ModalContent,
} from './modal.styles';
import Button from '../../components/button';

type Props = {
  innerProp: () => void,
};

export default (props: Props) => (
  <StyledModal innerRef={props.innerRef}>
    <ModalInner>
      <ModalTitle>{props.title}</ModalTitle>
      <ModalContent>{props.content}</ModalContent>
      <Button onClick={props.onClose}>Close</Button>
    </ModalInner>
  </StyledModal>
);



// WEBPACK FOOTER //
// ./src/components/modal/index.js